import React from "react";
import {
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  useTranslate,
  FunctionField,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
  EmptyMessage,
} from "../../shared/components/index.js";
import Merchants from "./merchants.js";
import ClientFilter from "./ClientFilter.js";

const DefaultClient = (props) => {
  const t = useTranslate();

  return (
    <CustomList
      filters={<ClientFilter {...props} />}
      actions={<CreateOnlyTopToolbar />}
    >
      <Datagrid
        empty={<EmptyMessage />}
        rowClick={false}
        bulkActionButtons={false}
      >
        <TextField source="phone" />
        <TextField source="email" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <ReferenceField source="category_id" reference="Category" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceArrayField source="tag_ids" reference="Tag" sortable={false}>
          <SingleFieldList linkType="show">
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Client.source.status.${record.status}`)
          }
        />
        <JsonField
          reference="Changes"
          source="unconfirmed_changes"
          label="resources.Client.fields.unconfirmed_changes.name"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <FunctionField
          source="deleted_at"
          render={(record) => {
            if (record && record.deleted_at) {
              return <DateField source="deleted_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.deleted"
        />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
      </Datagrid>
    </CustomList>
  );
};

const listClients = () => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.multiplePaymentGateways,
  ];

  if (nonDefaultClientRequires.some((plugin) => plugin === true)) {
    return Merchants[merchant].ListClient();
  } else {
    return <DefaultClient />;
  }
};

export default listClients;
